import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Modal,Button,Tree, Input, Dropdown, ConfigProvider, Radio} from "antd";
import {t} from "i18next";
import {TreeProps} from "antd/es/tree";
import {MAX_Z_INDEX} from "@/Const";
import './DialogBoardVisible.css'
import {loopAllNode} from "@/TreeUtils";
import {getImagePathWithTheme, isDarkMode} from "@/utils";
import Icon, {LoadingOutlined} from "@ant-design/icons";

const DialogBoardVisible = forwardRef((props: { onClose:any},ref)=>{
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))

    const {DirectoryTree} = Tree;
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [arrayTreeData,setArrayTreeData] = useState([]);
    const [radioValue,setRadioValue] = useState<any>('all');
    const [selectBoardDesc,setSelectBoardDesc] = useState('');
    const [arrayCheckedKeys,setArrayCheckedKeys] = useState<any>([]);
    const mArrayCheckedKeys = useRef<any>([]);
    const mArrayBackupCheckedKeys = useRef<any>([]);//备份的记录，如果没有点击save 就还原.
    const mCallback = useRef<any>();

    const onShowDialog = (treeData:any,callback:any)=>{
        setIsShowDialog(true);
        setArrayTreeData(treeData);
        mCallback.current = callback;

        setDefaultCheckedKeys(treeData);
        refreshSelectBoard(treeData);
    }

    const setDefaultCheckedKeys = (treeData:any)=>{
        const arrayChkKeys:any = [];
        let nAll = 0;
        loopAllNode(treeData,(node)=>{
            if (node.drawJson){
                nAll ++;
                if (node.isPublishChecked == false){

                }else{
                    arrayChkKeys.push(node.key);
                }
            }
        })
        if (arrayChkKeys.length != nAll){
            setRadioValue('partial');
        }
        mArrayCheckedKeys.current = arrayChkKeys;
        mArrayBackupCheckedKeys.current.push(...arrayChkKeys);
        setArrayCheckedKeys(arrayChkKeys);
    }


    /**
     * 刷新数量
     */
    const refreshSelectBoard = (treeData)=>{
        let nAll = 0;
        let nSelectBoards = 0;
        loopAllNode(treeData,(node)=>{
            if (node.drawJson){
                nAll ++;
                if (mArrayCheckedKeys.current.includes(node.key)){
                    nSelectBoards ++;
                }
            }
        })
        setSelectBoardDesc(t('SelectVBoard').replace('{0}',`${nSelectBoards}/${nAll}`));
    }

    /**
     * 刷新发布的显示状态
     */
    const refreshNodeCheck = ()=>{
        loopAllNode(arrayTreeData,(node)=>{
            if (node.drawJson){
                node.isPublishChecked = (mArrayCheckedKeys.current.includes(node.key))
            }
        })
    }

    /**
     * 还原checked
     */
    const restoreNodeCheck = ()=>{
        loopAllNode(arrayTreeData,(node)=>{
            if (node.drawJson){
                node.isPublishChecked = (mArrayBackupCheckedKeys.current.includes(node.key))
            }
        })
    }

    /**
     * 还原checked
     */
    const checkAll = ()=>{
        const arrayKeys:any = [];
        loopAllNode(arrayTreeData,(node)=>{
            if (node.drawJson){
                node.isPublishChecked = true;
                arrayKeys.push(node.key);
            }
        })
        mArrayCheckedKeys.current = arrayKeys;
        setArrayCheckedKeys(arrayKeys);
        refreshSelectBoard(arrayTreeData);
    }

    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {

    })

    const onCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
        console.log('onCheck', checkedKeys, info);
        if (radioValue == 'all')return;
        mArrayCheckedKeys.current = checkedKeys;
        setArrayCheckedKeys(checkedKeys);
        refreshSelectBoard(arrayTreeData);
        refreshNodeCheck();
    };

    return <Modal width={520} zIndex={MAX_Z_INDEX} bodyStyle={{height: `${590}px`,fontSize:'12px'}}
                  styles={{
                      content: {
                          padding:'16px 16px'
                      }
                  }}
                  afterClose={() => {
                      props.onClose();
                      //save 不会走这里。可以直接还原了。
                      restoreNodeCheck();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t('Board visibility')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -16px', flexGrow: '1'}}></div>

            <div style={{paddingLeft:'6px'}}>
                <Radio.Group onChange={(event) => {
                    setRadioValue(event.target.value);
                    if (event.target.value == 'all'){
                        checkAll();
                    }
                }} value={radioValue} style={{display: 'flex', flexDirection: 'column', flexGrow: '1',color:'var(--text-color)'}}>
                    <Radio value={"all"} style={{color:'var(--text-color)',fontSize:'12px'}}>{t("All boards")}</Radio>
                    <Radio className={'mt-16'} value={"partial"} style={{color:'var(--text-color)',fontSize:'12px'}}>{t("Partial boards")}</Radio>
                </Radio.Group>
            </div>


            <div className={'line mt-12'} style={{margin: '12px -16px', flexGrow: '1'}}></div>

            <span style={{color:'#666666',margin:'6px'}}>{selectBoardDesc}</span>

            <ConfigProvider
                theme={{
                    components: {
                        Tree: {
                            // colorPrimary: isPresentMode ? "#212121" : (isPresentMode ? '#DCEDFF' : '#DCEDFF00'),
                            colorPrimary: 'var(--primary-color)',
                            directoryNodeSelectedBg: false ? '#444444' : 'var(--select-background-color)',
                            indentSize: 0,
                            borderRadius: 0,
                            titleHeight: 32,
                            // 拖拽相关颜色---下面几个配置是一点用都没有。。。。
                            // dragOverBg: '#e6fffb',           // 拖拽经过可放置区域的背景色
                            // dragOverGapBg: '#f6ffed',        // 拖拽到间隙时的背景色
                            // dropIndicatorBg: '#1890ff',      // 拖拽指示线颜色
                        }
                    }
                }}>
                <DirectoryTree
                    style={{
                        margin: '8px 0 8px 0px',
                        height: '330px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        background: isDarkMode() ? '#1E1E1E' : 'transparent',
                        borderRadius: '8px',
                        opacity:radioValue == 'all'?'0.5':'1',
                    }}
                    className={'overwrite-direction-tree tree-fuck-css-left-dialog-board-visible'}
                    switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop: '-2px'}}
                                                              src={getImagePathWithTheme('tree_icon')}/>}/>}
                    onSelect={onSelect}
                    onCheck={onCheck}
                    checkable
                    defaultExpandAll={true}
                    showIcon={true}
                    checkedKeys={arrayCheckedKeys}
                    treeData={arrayTreeData}
                    selectedKeys={[]}
                    blockNode={true}
                    titleRender={(nodeData: any) => {
                        return (
                            <div className='' id={nodeData.key}
                                 style={{display: "flex", width: "450px", alignItems: "center"}}>
                                <span className='default-font-size font-family-regular hovered-text-white'
                                       style={{
                                           marginLeft: '1px',
                                           paddingLeft: '0px',
                                           whiteSpace: 'nowrap',
                                           textOverflow: 'ellipsis',
                                           overflow: 'hidden',
                                           cursor: "pointer",
                                           fontSize: '12px',
                                           marginBottom: '0px',
                                           marginTop: '1px',
                                           color:'var(--text-color)',
                                       }}>{nodeData.title}</span>
                            </div>
                        )
                    }}/>
            </ConfigProvider>

            <div className={'line mt-12'} style={{margin: '12px -16px', flexGrow: '1'}}></div>

            <div className={'flex-center mt-10 mb-4'}>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        if (mCallback.current){
                            mCallback.current();
                        }
                        props.onClose();
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '164px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogBoardVisible;